module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0066.jpg?v=e0f298dd";